var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{directives:[{name:"show",rawName:"v-show",value:(_vm.user),expression:"user"}]},[_c('nav-bar'),_c('transition',{attrs:{"name":"fade"}},[_c('div',[(_vm.hasContext)?_c('nav-drawer',{key:"navDrawer"}):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }